// Comprehensive country and state data mapping
export const countryStateData = {
  india: {
    label: "India",
    states: [
      { label: "Andhra Pradesh", value: "andhra_pradesh" },
      { label: "Arunachal Pradesh", value: "arunachal_pradesh" },
      { label: "Assam", value: "assam" },
      { label: "Bihar", value: "bihar" },
      { label: "Chhattisgarh", value: "chhattisgarh" },
      { label: "Goa", value: "goa" },
      { label: "Gujarat", value: "gujarat" },
      { label: "Haryana", value: "haryana" },
      { label: "Himachal Pradesh", value: "himachal_pradesh" },
      { label: "Jharkhand", value: "jharkhand" },
      { label: "Karnataka", value: "karnataka" },
      { label: "Kerala", value: "kerala" },
      { label: "Madhya Pradesh", value: "madhya_pradesh" },
      { label: "Maharashtra", value: "maharashtra" },
      { label: "Manipur", value: "manipur" },
      { label: "Meghalaya", value: "meghalaya" },
      { label: "Mizoram", value: "mizoram" },
      { label: "Nagaland", value: "nagaland" },
      { label: "Odisha", value: "odisha" },
      { label: "Punjab", value: "punjab" },
      { label: "Rajasthan", value: "rajasthan" },
      { label: "Sikkim", value: "sikkim" },
      { label: "Tamil Nadu", value: "tamil_nadu" },
      { label: "Telangana", value: "telangana" },
      { label: "Tripura", value: "tripura" },
      { label: "Uttar Pradesh", value: "uttar_pradesh" },
      { label: "Uttarakhand", value: "uttarakhand" },
      { label: "West Bengal", value: "west_bengal" },
      { label: "Delhi", value: "delhi" },
      { label: "Jammu and Kashmir", value: "jammu_kashmir" },
      { label: "Ladakh", value: "ladakh" },
      { label: "Chandigarh", value: "chandigarh" },
      { label: "Puducherry", value: "puducherry" },
      { label: "Andaman and Nicobar Islands", value: "andaman_nicobar" },
      { label: "Dadra and Nagar Haveli", value: "dadra_nagar_haveli" },
      { label: "Daman and Diu", value: "daman_diu" },
      { label: "Lakshadweep", value: "lakshadweep" },
    ]
  },
  usa: {
    label: "United States",
    states: [
      { label: "Alabama", value: "alabama" },
      { label: "Alaska", value: "alaska" },
      { label: "Arizona", value: "arizona" },
      { label: "Arkansas", value: "arkansas" },
      { label: "California", value: "california" },
      { label: "Colorado", value: "colorado" },
      { label: "Connecticut", value: "connecticut" },
      { label: "Delaware", value: "delaware" },
      { label: "Florida", value: "florida" },
      { label: "Georgia", value: "georgia" },
      { label: "Hawaii", value: "hawaii" },
      { label: "Idaho", value: "idaho" },
      { label: "Illinois", value: "illinois" },
      { label: "Indiana", value: "indiana" },
      { label: "Iowa", value: "iowa" },
      { label: "Kansas", value: "kansas" },
      { label: "Kentucky", value: "kentucky" },
      { label: "Louisiana", value: "louisiana" },
      { label: "Maine", value: "maine" },
      { label: "Maryland", value: "maryland" },
      { label: "Massachusetts", value: "massachusetts" },
      { label: "Michigan", value: "michigan" },
      { label: "Minnesota", value: "minnesota" },
      { label: "Mississippi", value: "mississippi" },
      { label: "Missouri", value: "missouri" },
      { label: "Montana", value: "montana" },
      { label: "Nebraska", value: "nebraska" },
      { label: "Nevada", value: "nevada" },
      { label: "New Hampshire", value: "new_hampshire" },
      { label: "New Jersey", value: "new_jersey" },
      { label: "New Mexico", value: "new_mexico" },
      { label: "New York", value: "new_york" },
      { label: "North Carolina", value: "north_carolina" },
      { label: "North Dakota", value: "north_dakota" },
      { label: "Ohio", value: "ohio" },
      { label: "Oklahoma", value: "oklahoma" },
      { label: "Oregon", value: "oregon" },
      { label: "Pennsylvania", value: "pennsylvania" },
      { label: "Rhode Island", value: "rhode_island" },
      { label: "South Carolina", value: "south_carolina" },
      { label: "South Dakota", value: "south_dakota" },
      { label: "Tennessee", value: "tennessee" },
      { label: "Texas", value: "texas" },
      { label: "Utah", value: "utah" },
      { label: "Vermont", value: "vermont" },
      { label: "Virginia", value: "virginia" },
      { label: "Washington", value: "washington" },
      { label: "West Virginia", value: "west_virginia" },
      { label: "Wisconsin", value: "wisconsin" },
      { label: "Wyoming", value: "wyoming" },
    ]
  },
  uk: {
    label: "United Kingdom",
    states: [
      { label: "England", value: "england" },
      { label: "Scotland", value: "scotland" },
      { label: "Wales", value: "wales" },
      { label: "Northern Ireland", value: "northern_ireland" },
    ]
  },
  canada: {
    label: "Canada",
    states: [
      { label: "Alberta", value: "alberta" },
      { label: "British Columbia", value: "british_columbia" },
      { label: "Manitoba", value: "manitoba" },
      { label: "New Brunswick", value: "new_brunswick" },
      { label: "Newfoundland and Labrador", value: "newfoundland_labrador" },
      { label: "Northwest Territories", value: "northwest_territories" },
      { label: "Nova Scotia", value: "nova_scotia" },
      { label: "Nunavut", value: "nunavut" },
      { label: "Ontario", value: "ontario" },
      { label: "Prince Edward Island", value: "prince_edward_island" },
      { label: "Quebec", value: "quebec" },
      { label: "Saskatchewan", value: "saskatchewan" },
      { label: "Yukon", value: "yukon" },
    ]
  },
  australia: {
    label: "Australia",
    states: [
      { label: "Australian Capital Territory", value: "australian_capital_territory" },
      { label: "New South Wales", value: "new_south_wales" },
      { label: "Northern Territory", value: "northern_territory" },
      { label: "Queensland", value: "queensland" },
      { label: "South Australia", value: "south_australia" },
      { label: "Tasmania", value: "tasmania" },
      { label: "Victoria", value: "victoria" },
      { label: "Western Australia", value: "western_australia" },
    ]
  },
  germany: {
    label: "Germany",
    states: [
      { label: "Baden-Württemberg", value: "baden_wurttemberg" },
      { label: "Bavaria", value: "bavaria" },
      { label: "Berlin", value: "berlin" },
      { label: "Brandenburg", value: "brandenburg" },
      { label: "Bremen", value: "bremen" },
      { label: "Hamburg", value: "hamburg" },
      { label: "Hesse", value: "hesse" },
      { label: "Lower Saxony", value: "lower_saxony" },
      { label: "Mecklenburg-Vorpommern", value: "mecklenburg_vorpommern" },
      { label: "North Rhine-Westphalia", value: "north_rhine_westphalia" },
      { label: "Rhineland-Palatinate", value: "rhineland_palatinate" },
      { label: "Saarland", value: "saarland" },
      { label: "Saxony", value: "saxony" },
      { label: "Saxony-Anhalt", value: "saxony_anhalt" },
      { label: "Schleswig-Holstein", value: "schleswig_holstein" },
      { label: "Thuringia", value: "thuringia" },
    ]
  },
  france: {
    label: "France",
    states: [
      { label: "Auvergne-Rhône-Alpes", value: "auvergne_rhone_alpes" },
      { label: "Bourgogne-Franche-Comté", value: "bourgogne_franche_comte" },
      { label: "Brittany", value: "brittany" },
      { label: "Centre-Val de Loire", value: "centre_val_de_loire" },
      { label: "Corsica", value: "corsica" },
      { label: "Grand Est", value: "grand_est" },
      { label: "Hauts-de-France", value: "hauts_de_france" },
      { label: "Île-de-France", value: "ile_de_france" },
      { label: "Normandy", value: "normandy" },
      { label: "Nouvelle-Aquitaine", value: "nouvelle_aquitaine" },
      { label: "Occitania", value: "occitania" },
      { label: "Pays de la Loire", value: "pays_de_la_loire" },
      { label: "Provence-Alpes-Côte d'Azur", value: "provence_alpes_cote_azur" },
    ]
  },
  japan: {
    label: "Japan",
    states: [
      { label: "Hokkaido", value: "hokkaido" },
      { label: "Aomori", value: "aomori" },
      { label: "Iwate", value: "iwate" },
      { label: "Miyagi", value: "miyagi" },
      { label: "Akita", value: "akita" },
      { label: "Yamagata", value: "yamagata" },
      { label: "Fukushima", value: "fukushima" },
      { label: "Ibaraki", value: "ibaraki" },
      { label: "Tochigi", value: "tochigi" },
      { label: "Gunma", value: "gunma" },
      { label: "Saitama", value: "saitama" },
      { label: "Chiba", value: "chiba" },
      { label: "Tokyo", value: "tokyo" },
      { label: "Kanagawa", value: "kanagawa" },
      { label: "Niigata", value: "niigata" },
      { label: "Toyama", value: "toyama" },
      { label: "Ishikawa", value: "ishikawa" },
      { label: "Fukui", value: "fukui" },
      { label: "Yamanashi", value: "yamanashi" },
      { label: "Nagano", value: "nagano" },
      { label: "Gifu", value: "gifu" },
      { label: "Shizuoka", value: "shizuoka" },
      { label: "Aichi", value: "aichi" },
      { label: "Mie", value: "mie" },
      { label: "Shiga", value: "shiga" },
      { label: "Kyoto", value: "kyoto" },
      { label: "Osaka", value: "osaka" },
      { label: "Hyogo", value: "hyogo" },
      { label: "Nara", value: "nara" },
      { label: "Wakayama", value: "wakayama" },
      { label: "Tottori", value: "tottori" },
      { label: "Shimane", value: "shimane" },
      { label: "Okayama", value: "okayama" },
      { label: "Hiroshima", value: "hiroshima" },
      { label: "Yamaguchi", value: "yamaguchi" },
      { label: "Tokushima", value: "tokushima" },
      { label: "Kagawa", value: "kagawa" },
      { label: "Ehime", value: "ehime" },
      { label: "Kochi", value: "kochi" },
      { label: "Fukuoka", value: "fukuoka" },
      { label: "Saga", value: "saga" },
      { label: "Nagasaki", value: "nagasaki" },
      { label: "Kumamoto", value: "kumamoto" },
      { label: "Oita", value: "oita" },
      { label: "Miyazaki", value: "miyazaki" },
      { label: "Kagoshima", value: "kagoshima" },
      { label: "Okinawa", value: "okinawa" },
    ]
  },
  china: {
    label: "China",
    states: [
      { label: "Beijing", value: "beijing" },
      { label: "Shanghai", value: "shanghai" },
      { label: "Tianjin", value: "tianjin" },
      { label: "Chongqing", value: "chongqing" },
      { label: "Hebei", value: "hebei" },
      { label: "Shanxi", value: "shanxi" },
      { label: "Liaoning", value: "liaoning" },
      { label: "Jilin", value: "jilin" },
      { label: "Heilongjiang", value: "heilongjiang" },
      { label: "Jiangsu", value: "jiangsu" },
      { label: "Zhejiang", value: "zhejiang" },
      { label: "Anhui", value: "anhui" },
      { label: "Fujian", value: "fujian" },
      { label: "Jiangxi", value: "jiangxi" },
      { label: "Shandong", value: "shandong" },
      { label: "Henan", value: "henan" },
      { label: "Hubei", value: "hubei" },
      { label: "Hunan", value: "hunan" },
      { label: "Guangdong", value: "guangdong" },
      { label: "Guangxi", value: "guangxi" },
      { label: "Hainan", value: "hainan" },
      { label: "Sichuan", value: "sichuan" },
      { label: "Guizhou", value: "guizhou" },
      { label: "Yunnan", value: "yunnan" },
      { label: "Shaanxi", value: "shaanxi" },
      { label: "Gansu", value: "gansu" },
      { label: "Qinghai", value: "qinghai" },
      { label: "Taiwan", value: "taiwan" },
      { label: "Inner Mongolia", value: "inner_mongolia" },
      { label: "Xinjiang", value: "xinjiang" },
      { label: "Tibet", value: "tibet" },
      { label: "Ningxia", value: "ningxia" },
      { label: "Hong Kong", value: "hong_kong" },
      { label: "Macau", value: "macau" },
    ]
  },
  brazil: {
    label: "Brazil",
    states: [
      { label: "Acre", value: "acre" },
      { label: "Alagoas", value: "alagoas" },
      { label: "Amapá", value: "amapa" },
      { label: "Amazonas", value: "amazonas" },
      { label: "Bahia", value: "bahia" },
      { label: "Ceará", value: "ceara" },
      { label: "Distrito Federal", value: "distrito_federal" },
      { label: "Espírito Santo", value: "espirito_santo" },
      { label: "Goiás", value: "goias" },
      { label: "Maranhão", value: "maranhao" },
      { label: "Mato Grosso", value: "mato_grosso" },
      { label: "Mato Grosso do Sul", value: "mato_grosso_do_sul" },
      { label: "Minas Gerais", value: "minas_gerais" },
      { label: "Pará", value: "para" },
      { label: "Paraíba", value: "paraiba" },
      { label: "Paraná", value: "parana" },
      { label: "Pernambuco", value: "pernambuco" },
      { label: "Piauí", value: "piaui" },
      { label: "Rio de Janeiro", value: "rio_de_janeiro" },
      { label: "Rio Grande do Norte", value: "rio_grande_do_norte" },
      { label: "Rio Grande do Sul", value: "rio_grande_do_sul" },
      { label: "Rondônia", value: "rondonia" },
      { label: "Roraima", value: "roraima" },
      { label: "Santa Catarina", value: "santa_catarina" },
      { label: "São Paulo", value: "sao_paulo" },
      { label: "Sergipe", value: "sergipe" },
      { label: "Tocantins", value: "tocantins" },
    ]
  },
  other: {
    label: "Other",
    states: [
      { label: "Other", value: "other" },
    ]
  }
};

// Get all countries for dropdown
export const getCountryOptions = () => {
  return Object.keys(countryStateData).map(key => ({
    label: countryStateData[key].label,
    value: key
  }));
};

// Get states for a specific country
export const getStateOptions = (countryValue) => {
  if (!countryValue || !countryStateData[countryValue]) {
    return [];
  }
  return countryStateData[countryValue].states;
};

// Helper function to find country by value (for backward compatibility)
export const findCountryByState = (stateValue) => {
  for (const [countryKey, countryData] of Object.entries(countryStateData)) {
    const stateExists = countryData.states.some(state => state.value === stateValue);
    if (stateExists) {
      return countryKey;
    }
  }
  return null;
};

// Helper to normalize country values from existing data
export const normalizeCountryValue = (value) => {
  const mapping = {
    'indian': 'india',
    'american': 'usa',
    'british': 'uk',
    'canadian': 'canada',
    'australian': 'australia',
    'german': 'germany',
    'french': 'france',
    'japanese': 'japan',
    'chinese': 'china',
    'brazilian': 'brazil'
  };
  return mapping[value] || value;
};
